var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CustomSnackbar',{ref:"snackbar"}),_c('EditItemNav',{ref:"nav",on:{"submit":_vm.save}}),_c('EditItemWorkspace',{ref:"workspace",on:{"change":function($event){return _vm.onWorkspaceChange()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }